// Available domain events emitted by Backend Sprint 11. Mirrors the
// six events the EnqueueWebhookDeliveriesListener subscribes to —
// keep this list in sync with Sprint 15 docs until the backend exposes
// `GET /admin/webhooks/available-events`.
export const WEBHOOK_AVAILABLE_EVENTS = [
    { value: 'order.placed',     labelEn: 'Order placed',     labelAr: 'تم إنشاء الطلب' },
    { value: 'order.shipped',    labelEn: 'Order shipped',    labelAr: 'تم شحن الطلب' },
    { value: 'order.delivered',  labelEn: 'Order delivered',  labelAr: 'تم تسليم الطلب' },
    { value: 'order.refunded',   labelEn: 'Order refunded',   labelAr: 'تم استرداد الطلب' },
    { value: 'order.cancelled',  labelEn: 'Order cancelled',  labelAr: 'تم إلغاء الطلب' },
    { value: 'return.submitted', labelEn: 'Return submitted', labelAr: 'تم تقديم طلب إرجاع' },
];

export const DELIVERY_STATUS_META = {
    pending:   { color: 'warning', labelEn: 'Pending',   labelAr: 'قيد الإرسال' },
    delivered: { color: 'success', labelEn: 'Delivered', labelAr: 'تم التسليم' },
    failed:    { color: 'error',   labelEn: 'Failed',    labelAr: 'فشل' },
    abandoned: { color: 'default', labelEn: 'Abandoned', labelAr: 'تم التخلي' },
};

export const LAST_STATUS_META = {
    delivered: { color: 'success', labelEn: 'OK',     labelAr: 'تم' },
    failed:    { color: 'error',   labelEn: 'Failed', labelAr: 'فشل' },
    pending:   { color: 'warning', labelEn: 'Pending', labelAr: 'قيد الإرسال' },
    abandoned: { color: 'default', labelEn: 'Abandoned', labelAr: 'تم التخلي' },
};
